import React from 'react';
import './InputFormsForSubCategories.scss';
import { closeInputForms, idSubCategoriesCreate } from '../../../adminSlice';

export default class AddInputFormsForSubCategories  extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            userInputId: '',
            userInputContent: '',           
          
        }
      
       this.handleUserInputContent = this.handleUserInputContent.bind(this);
 
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;
        const item = {
            sub_name: this.state.userInputContent,
            main_id: this.props.adminState.selectedCategory,
            user_id: this.props.userId,
            
        }
        console.log(item);
        dispatch(idSubCategoriesCreate(item));  
}
// ENTER INPUT
handleUserInputContent(e) {
    this.setState(
        {
            userInputContent: e.target.value
        }
    )
}




// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
    return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openAddInputFormsForSubCategories) {
        return(
            <div className="InputFormsForSubCategories">
                           


             <p>Создать новую подкатегорию:</p>
             <form>
             
                 <label>
                     Введите название подкатегории: </label>
                 <input id="content" type="text"  onChange={this.handleUserInputContent} 
                 />
                 


             </form>
             <button onClick={this.onSend}>OK</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}